import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom';
// import 'antd/dist/antd.css'----按需加载，不要直接这样引入
import './static/css/normalize.css'
import './static/js/flexible'
import registerServiceWorker from './registerServiceWorker';

import Login from './page/Login/Login';
import App from './page/App/index';
import Blankpage from './page/Blankpage/index';
import RedirectIndex from './page/App/common/RedirectIndex';
import NotFound from './page/App/common/404';

 // exact: 表示路由是严格匹配的
ReactDOM.render(
    <HashRouter>
      <Switch>
        <Route exact path="/login" component={Login}/>
        <Route path="/home" component={App}/>
        <Route path="/Blankpage" component={Blankpage}/>
        <Route exact path="/" component={RedirectIndex}/>
        <Route path="*" component={NotFound}/>
      </Switch>
    </HashRouter>, 
    
document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js